export default "__VITE_ASSET__JRXlBIhF__"